$(document).ready(function(){

    var loadingElement = '<img src="data:image/gif;base64,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" />';

    const url = "https://i828.people.cn/"

   function validateInput(input) {
        // 只过滤控制字符和特殊非法字符，允许中文等Unicode字符
        // 控制字符范围：0-31, 127
        // 特殊非法字符：根据实际需求添加
        const invalidChars = /[\x00-\x1F\x7F\s`~!@#$%^&*()+=|{}':;',\[\].<>/?~！@#￥%……&*（）——+|{}【】‘；：”“’。，、？]/g;

        return input.replace(invalidChars, function(ch) {
            // 对于控制字符，替换为HTML实体
            if (ch.charCodeAt(0) <= 31 || ch.charCodeAt(0) === 127) {
            return '&#' + ch.charCodeAt(0) + ';';
            }
            // 对于其他非法字符，可以选择替换为空或提示
            return '';
        });
        }

   $('input[type="text"].input_1, textarea.desc').on('input', function() {
const value = $(this).val();
const validatedValue = validateInput(value);

if (value !== validatedValue) {
    $(this).val(validatedValue);
    // 使用更友好的提示方式
    if (!$(this).data('error-shown')) {
    $(this).data('error-shown', true);
    // 创建一个临时提示元素
    const errorTip = $('<div class="error-tip">请勿输入非法字符</div>');
    errorTip.css({
        'position': 'absolute',
        'background': '#ff4d4f',
        'color': 'white',
        'padding': '4px 8px',
        'border-radius': '4px',
        'font-size': '12px',
        'margin-top': '5px',
        'z-index': '1000'
    });
    $(this).after(errorTip);
    // 定位提示框
    const offset = $(this).offset();
    errorTip.offset({
        top: offset.top + $(this).outerHeight(),
        left: offset.left
    });
    // 3秒后移除提示
    setTimeout(function() {
    errorTip.fadeOut(300, function() {
        $(this).remove();
    });
    $(this).removeData('error-shown');
    }.bind(this), 3000);
    }
}
});


    let jiangs = 0;
    let jiangArray = "";
    $('.jiang').on('click',function(e){
        let status = $(this).attr('class');
		$('.choose4 span').find('b').removeClass('active');
		$(this).addClass('active');
		let data = $(this).attr('data');
		jiangArray  = data;
		$('.tabBox').hide();
		$('.tabBox').eq(data-1).show();
    })

    let danwei = 0;
    let danweiArray = "";
    $('.danwei').on('click',function(e){
        let status = $(this).attr('class');
        $('.danwei').removeClass('active');
        if(status == 'danwei'){
            $(this).addClass('active');
            let data = $(this).attr('data');
            danweiArray = data;
        }else{
            $(this).removeClass('active');
            danweiArray = [];
        } 
    })
	
    let fuwu1 = "";
    $('.fuwu1').on('click',function(e){
        $('.fuwu1').removeClass('active');
       $(this).addClass('active');
            fuwu1 = [];
            let data = $(this).attr('data');
            fuwu1 = data;
        console.log(fuwu1)
        
    })
    let fuwu2 = "";
    $('.fuwu2').on('click',function(e){
        $('.fuwu2').removeClass('active');
       $(this).addClass('active');
            let data = $(this).attr('data');
            fuwu2 = data;
        console.log(fuwu2)
        
    })
    let fuwu3 = "";
    $('.fuwu3').on('click',function(e){
        $('.fuwu3').removeClass('active');
       $(this).addClass('active');
            fuwu3 = [];
            let data = $(this).attr('data');
            fuwu3 = data;
        console.log(fuwu3)
        
    })

    let keyArray = [];
    $("#key1").on('input',function(e){
        keyArray[0] = $(this).val();
    })
     $("#key2").on('input',function(e){
        keyArray[1] = $(this).val();
    })
     $("#key3").on('input',function(e){
        keyArray[2] = $(this).val();
    })
     $("#key4").on('input',function(e){
        keyArray[3] = $(this).val();
    })
     $("#key5").on('input',function(e){
        keyArray[4] = $(this).val();
    })
    $('.key').on('click',function(e){
        let status = $(this).attr('class');
//        $('.danwei3').removeClass('active');

        if(status == 'key'){
            if(keyArray.length == 5){
                return
            }
            $(this).addClass('active');
            let data = $(this).attr('data');
            keyArray.push(data);
            if(keyArray[0] != ""){
                $('.keylist').eq(0).val(keyArray[0])
            }
            if(keyArray[1] != ""){
                $('.keylist').eq(1).val(keyArray[1])
            }
            if(keyArray[2] != ""){
                $('.keylist').eq(2).val(keyArray[2])
            }
            if(keyArray[3] != ""){
                $('.keylist').eq(3).val(keyArray[3])
            }
            if(keyArray[4] != ""){
                $('.keylist').eq(4).val(keyArray[4])
            }
        }
		if(status == "key active"){
			$(this).removeClass('active');
			let data = $(this).attr('data');
			let index = keyArray.indexOf(data);
			if(index !== -1){
				keyArray.splice(index,1)
                $('.keylist').eq(index).val("")

			}
		}
        console.log(keyArray)
        
    })

    function sum (m,n){
        　　var num = Math.floor(Math.random()*(m - n) + n);
            return num;
   }
    let sui = sum(1,100);
    let time = Date.parse(new Date());
    let sign = time+sui;

    function upFile(file,status){
        var formData = new FormData();
        formData.append('file', file); 
        formData.append('label', status);

        $('.loading').show();
        $('.loadingBox').html(loadingElement);
        $('.blackBg').show();
        
        $.ajax({
            type: 'POST',
            url: "https://feature.people.cn/api/zos/upload",
            data: formData,
            dataType: 'json',
            processData: false,
            contentType: false,
            success: function(res) {
                console.log('上传图片信息:', res)
                $('.loading').hide();
                $('.blackBg').hide();
				
				if(status == "logo"){
                  alert('logo上传成功!')
                    $('#logo').attr({'src':res.url})
                    $('#cover').val(res.filename)
                    }
                    if(status == "chengnuo"){
                        alert('声明上传成功!')
                        $('#chengnuo').val(res.filename)
                    }
                    if(status == "qita"){
                        alert('其他材料上传成功!')
                        $('#qitabox').val(res.filename)
                    }
                    if(status == "anli"){
                       alert('案例图片上传成功!')
                        $('#anli').attr({'src':res.url})
                        $('#anlicover').val(res.filename)
                    }
		
            },
            error: function() {

            }
        })
    }

    $('#logoup').on('change',function(event){
        let status = "logo";
        var evt = event || window.event;
        var target = evt.target || evt.srcElement
        var files = target.files,
			file;
            
        if(files && files.length > 0) {
            // 获取目前上传的文件
            file = files[0];
        	var fileSize = files[0].size;
                    console.log(file)
			//console.log('图片大小:', fileSize)
//            if(!/jpg|png|pdf/ig.test(file.name)) {
//                $('.imgFile').val(null);
//                alert('请上传jpg或pdf格式文件');
//                return false;
//            }
             
			if(fileSize > 1000000){
				alert('请将图片大小控制在1MB以内');
                return false;
			}
			var reader = new FileReader();
        	reader.onload = function (e) {
            var data = e.target.result;
				// 加载图片获取图片真实宽度和高度
				var image = new Image();
				image.onload = function() {
					var realWidth = image.width,
					realHeight = image.height;
					if(realWidth == 655 || realHeight == 415){
						upFile(file,status);
					}
					else{
						alert('申报主体logo须符合图片分辨率655*415');
						return false;
					}
				};
				image.src = data;
			};
			reader.readAsDataURL(file);
		}
    })
    $('#anliup').on('change',function(event){
        let status = "anli";
        var evt = event || window.event;
        var target = evt.target || evt.srcElement
        var files = target.files,
			file;
            
        if(files && files.length > 0) {
            // 获取目前上传的文件
            file = files[0];
        	var fileSize = files[0].size;
			//console.log('图片大小:', fileSize)
//            if(!/jpg|png|pdf/ig.test(file.name)) {
//                $('.imgFile').val(null);
//                alert('请上传jpg或pdf格式文件');
//                return false;
//            }
             
			if(fileSize > 1000000){
				alert('请将图片大小控制在1MB以内');
                return false;
			}
			var reader = new FileReader();
        	reader.onload = function (e) {
            var data = e.target.result;
				// 加载图片获取图片真实宽度和高度
				var image = new Image();
				image.onload = function() {
					var realWidth = image.width,
					realHeight = image.height;
					if(realWidth == 655 || realHeight == 415){
						upFile(file,status);
					}
					else{
						alert('案例图片分辨率必须为655*415');
						return false;
					}
				};
				image.src = data;
			};
			reader.readAsDataURL(file);
		}
    })
    $('#chengnuoshu').on('change',function(event){
        let status = "chengnuo";
        var evt = event || window.event;
        var target = evt.target || evt.srcElement
        var files = target.files,
            file;
		
        if(files && files.length > 0) {
            // 获取目前上传的文件
            file = files[0];
            var fileSize = files[0].size;
            console.log('图片文件:', file)
//            if(!/jpg|png|pdf|jpeg/ig.test(file.name)) {
//                $('.imgFile').val(null);
//                alert('请上传jpg或pdf格式文件');
//                return false;
//            }
            if(fileSize > 3000000){
                            alert('请将图片大小控制在3MB以内');
                            return false;
            }

            upFile(file,status);
        } 
    })
      $('#qita').on('change',function(event){
        let status = "qita";
        var evt = event || window.event;
        var target = evt.target || evt.srcElement
        var files = target.files,
            file;
		
        if(files && files.length > 0) {
            // 获取目前上传的文件
            file = files[0];
            console.log('图片文件:', file)
//            if(!/jpg|png|pdf|jpeg/ig.test(file.name)) {
//                $('.imgFile').val(null);
//                alert('请上传jpg或pdf格式文件');
//                return false;
//            }

            upFile(file,status);
        } 
    })


    /*===
    获取token
    ====*/
    // localStorage.setItem('token','eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJhdWQiOiIxIiwianRpIjoiNmQ0ZWE0YWQyNDkxZGE5ODlhOGMyNmQwZDg5NGE2MzVkMjliZjViZDY4MjgyOTRkZGRjNzQxOGY2NmUyOWQ1MjVjODk5NWQ2NDM3ODVkYTkiLCJpYXQiOjE3NTM4NDQ2NzMuMjIyMjY5LCJuYmYiOjE3NTM4NDQ2NzMuMjIyMjcyLCJleHAiOjE3NTY0MzY2NzMuMTk0OTQ3LCJzdWIiOiI5Iiwic2NvcGVzIjpbXX0.b_JqMngyefJk34WqmL7NvqhDgDO7YGLusW0aqTBQcQkRqj6W8_BSZ6sMM24_o4agN_JQ_BDU2eLJkDX_XihXNQ')

    const token = localStorage.getItem('token');


    function loadUser(){
        return new Promise((resolve, reject) => {
            $.ajax({
                type: 'GET',
                url: url + 'api/user',
                dataType: 'json',
                headers: {
                    'Authorization': `Bearer `+token
                },
                processData: false,
                contentType: false,
                success: function(res) {
                    console.log('用户信息:', res)
                    resolve(res)
                },
                error: function(error) {
                //   alert(error.responseJSON.message)
                  resolve(417)
                }
            })
        })
    }
    loadUser().then(res => {
        if(res.message == "success"){
            $('.userinfoBox').hide();
            $('.userinfo').show();
            $('#username').html(res.data.username)
        }
        if(res == 417){
            alert('请登录后填写')
        }
    })

    $('.logout').on('click',function(){

       $.ajax({
                type: 'GET',
                url: url + 'api/logout',
                dataType: 'json',
                headers: {
                    'Authorization': `Bearer `+ token
                },
                processData: false,
                contentType: false,
                success: function(res) {
                     $('.userinfoBox').show();
                    $('.userinfo').hide();
                            localStorage.removeItem('token');
                            localStorage.removeItem("userinfo");
                },
                error: function(error) {

                }
            })
    })

    /*===
    获取默认数据
    ====*/
    function loadData(){
        let defaultData = JSON.parse(localStorage.getItem('defaultData'));
                for (let key in defaultData) {
                    if (defaultData.hasOwnProperty(key)) {
                        // console.log('key',key)
                        if(key == 'cover' && defaultData[key] != ""){
                            $('#anli').attr('src',defaultData[key])
                            $('#anlicover').val(defaultData[key])
                        }
                        if(key == 'statement' && defaultData[key] != ""){
                            $('#chengnuo').val(defaultData[key])
                        }
                        if(key == 'attachment' && defaultData[key] != ""){
                            $('#qitabox').val(defaultData[key])
                        }
                        if(key == 'share' && defaultData[key] != ""){
                            $('#logo').attr('src',defaultData[key])
                             $('#cover').val(defaultData[key])
                        }
                        if(key == 'dimensions' && defaultData[key] != ""){
                            jiangArray = defaultData[key]
                            $('.jiang').each(function(index,element){
                                if($(this).attr('data') == defaultData[key]){
                                    $(this).addClass('active')
                                }
                            })
                        }
                        if(key == 'industry' && defaultData[key] != ""){
                            danweiArray = defaultData[key]
                            $('.danwei').each(function(index,element){
                                if($(this).attr('data') == defaultData[key]){
                                    $(this).addClass('active')
                                }
                            })
                        }
                        if(key == 'is_research' && defaultData[key] != ""){
                            fuwu1 = defaultData[key]
                            $('.fuwu1').each(function(index,element){
                                if($(this).attr('data') == defaultData[key]){
                                    $(this).addClass('active')
                                }
                            })
                        }
                        if(key == 'is_roadshow' && defaultData[key] != ""){
                            fuwu2 = defaultData[key]
                            $('.fuwu2').each(function(index,element){
                                if($(this).attr('data') == defaultData[key]){
                                    $(this).addClass('active')
                                }
                            })
                        }
                        if(key == 'is_join' && defaultData[key] != ""){
                            fuwu3 = defaultData[key]
                            $('.fuwu3').each(function(index,element){
                                if($(this).attr('data') == defaultData[key]){
                                    $(this).addClass('active')
                                }
                            })
                        }
                        if(key == 'tags' && defaultData[key] != ""){
                             let keyobject = defaultData[key].split(',')

                             keyArray = keyobject
                            $('.keylist').each(function(index,element){
                                $(this).val(keyArray[index])
                            })
                            $('.key').each(function(index,element){
                                if($(this).attr('data') == keyobject[index]){
                                    $(this).addClass('active')
                                }
                            })
                        }
                        $(`#${key}`).val(defaultData[key]);
                    }
                }
    }
    if(localStorage.getItem('defaultData')){
       loadData();
    }
    /*===
    保存数据
    ====**/
    $('#baocun').on('click',function(){
        let title = $('#title').val();
        let ent_name = $("#ent_name").val();
        let contact = $("#contact").val();
        let phone = $("#phone").val();
        let short_name = $("#short_name").val();
        let address = $("#address").val();
        let email = $("#email").val();
        let posization = $("#posization").val();
        let summary = $('#summary').val();
        let innovation = $('#innovation').val();
        let practical = $('#practical').val();
        let experience = $('#experience').val();
        let development = $('#development').val();
        let statement = $('#chengnuo').val();
        let cover = $('#anlicover').val();
        let cover_desc = $('#cover_desc').val();
        let ent_desc = $('#ent_desc').val();
        let share = $('#cover').val();
        let attachment = $('#qita').val();
        let qita = $('#industry').val();

        var formData = new FormData();
        formData.append('title', title); 
        formData.append('ent_name',ent_name)
        formData.append('contact',contact)
        formData.append('short_name',short_name)
        formData.append('dimensions',jiangArray)
        formData.append('industry',danweiArray+qita)
        formData.append('phone',phone)
        formData.append('email',email)
        formData.append('posization',posization)
        formData.append('address',address)
        formData.append('is_research',fuwu1)
        formData.append('is_roadshow',fuwu2)
        formData.append('is_join',fuwu3)
        formData.append('summary',summary)
        formData.append('innovation',innovation)
        formData.append('practical',practical)
        formData.append('experience',experience)
        formData.append('development',development)
        formData.append('tags',keyArray.toString())
        formData.append('statement',statement)
        formData.append('cover',cover)
        formData.append('cover_desc',cover_desc)
        formData.append('ent_desc',ent_desc)
        formData.append('share',share)
        formData.append('attachment',attachment)

        const formDataObj = {};
        for (let [key, value] of formData.entries()) {
        formDataObj[key] = value;
        }
        localStorage.setItem('defaultData', JSON.stringify(formDataObj));
        alert('保存成功！')

    })
    /*====
    提交数据
    ======*/
    $('#tijiao').on('click',function(){

        let title = $('#title').val();
        let ent_name = $("#ent_name").val();
        let contact = $("#contact").val();
        let phone = $("#phone").val();
        let short_name = $("#short_name").val();
        let address = $("#address").val();
        let email = $("#email").val();
        let posization = $("#posization").val();
        let summary = $('#summary').val();
        let innovation = $('#innovation').val();
        let practical = $('#practical').val();
        let experience = $('#experience').val();
        let development = $('#development').val();
        let statement = $('#chengnuo').val();
        let cover = $('#anlicover').val();
        let cover_desc = $('#cover_desc').val();
        let ent_desc = $('#ent_desc').val();
        let share = $('#cover').val();
        let attachment = $('#qita').val();
        let qita = $('#industry').val();
        let key1 = $('#key1').val();
        let key2 = $('#key2').val();
        let key3 = $('#key3').val();
        let key4 = $('#key4').val();
        let key5 = $('#key5').val();

        if(title == ''){
          alert('案例名称不能为空')
          return false
        }

        if(ent_name == ''){
          alert('报送单位全称不能为空')
          return false
        }
        if(short_name == ''){
          alert('报送单位简称不能为空')
          return false
        }
   
        if(jiangArray == ""){
          alert('必须选择案例类别')
          return false
        }

         if(danweiArray == ""){
            alert('必须选择法人单位性质')
            return false
          }

          if(contact == ''){
          alert('联系人不能为空')
          return false
        }

         if(posization == ''){
          alert('联系人职务不能为空')
          return false
        }
        if(phone == ''){
          alert('联系人电话不能为空')
          return false
        }
        if(email == ''){
          alert('联系人邮箱不能为空')
          return false
        }
        if(address == ''){
          alert('联系人地址不能为空')
          return false
        }


        if(summary == ''){
          alert('案例摘要不能为空')
          return false
        }

        if(innovation == ''){
          alert('创新举措不能为空')
          return false
        }

        if(practical == ''){
          alert('实践成效不能为空')
          return false
        }

        if(experience == ''){
          alert('经验总结不能为空')
          return false
        }

        if(development == ''){
          alert('发展规划不能为空')
          return false
        }
        
        if(keyArray.length == 0 && key1 == "" && key2 == "" && key3 == "" && key4 == "" && key5 == ""){
          alert('案例关键词不能为空')
          return false
        }

        if(statement == ''){
          alert('声明不能为空')
          return false
        }
        if(cover == ''){
          alert('案例图片不能为空')
          return false
        }
        if(cover_desc == ''){
          alert('案例图片说明不能为空')
          return false
        }
        if(ent_desc == ''){
          alert('申报主体简介不能为空')
          return false
        }
        if(share == ''){
          alert('申报主体logo图片不能为空')
          return false
        }


		
        var formData = new FormData();
        formData.append('title', title); 
        formData.append('ent_name',ent_name)
        formData.append('short_name',short_name)
        formData.append('contact',contact)
        formData.append('dimensions',jiangArray)
        formData.append('industry',danweiArray+qita)
        formData.append('phone',phone)
        formData.append('email',email)
        formData.append('posization',posization)
        formData.append('address',address)
        formData.append('is_research',fuwu1)
        formData.append('is_roadshow',fuwu2)
        formData.append('is_join',fuwu3)
        formData.append('summary',summary)
        formData.append('innovation',innovation)
        formData.append('practical',practical)
        formData.append('experience',experience)
        formData.append('development',development)
        formData.append('tags',keyArray.toString()+key1+key2+key3+key4+key5)
        formData.append('statement',statement)
        formData.append('cover',cover)
        formData.append('cover_desc',cover_desc)
        formData.append('ent_desc',ent_desc)
        formData.append('share',share)
        formData.append('attachment',attachment)


        $.ajax({
            type: 'POST',
            url: url + 'api/fincase',
            data: formData,
            dataType: 'json',
            headers: {
                'Authorization': `Bearer `+token
            },
            processData: false,
            contentType: false,
            success: function(res) {
                console.log('提交信息:', res)
                if(res.code == 0){
                    alert(res.message)
                    localStorage.removeItem('defaultData')
                }else{
                    alert(res.message)
                    localStorage.removeItem('defaultData')
                }

            },
            error: function(error) {
              alert(error.responseJSON.message)
            }
        })
    })
})